import {cssClasses, numbers} from '@material/textfield/constants';

/**
 * As of v3 there is no mechanism for material components to know that measurable widths
 * have changed - so if a textfield has a value, is a textarea, and was rendered prior to
 * being measurable in the DOM, we wind up with a missing floating label
 * This will hopefully go away as we switch over to react
 * @function
 * @param {MDCTextfield} textfield Instance of mdc-textfield
 */
export const notchOutlinePatch = (textfield) => {
	// Do not patch twice
	if (!textfield || textfield.notchOutlinePatched_) return;
	textfield.notchOutlinePatched_ = true;

	const foundation = textfield.foundation_;
	const adapter = foundation.adapter_;
	foundation.notchOutline = _.wrap(
		foundation.notchOutline,
		(notchOutline, openNotch) => {
			textfield.notchOutlinePatchTimeout &&
				clearTimeout(textfield.notchOutlinePatchTimeout);
			if (!adapter.hasOutline()) return;
			if (!openNotch) return notchOutline.call(foundation, openNotch);

			const isDense = adapter.hasClass(cssClasses.DENSE);
			const labelScale = isDense
				? numbers.DENSE_LABEL_SCALE
				: numbers.LABEL_SCALE;
			const labelWidth = adapter.getLabelWidth() * labelScale;
			if (!labelWidth || isNaN(labelWidth)) {
				return (textfield.notchOutlinePatchTimeout = setTimeout(() => {
					foundation.notchOutline(openNotch);
				}, 100));
			}
			adapter.notchOutline(labelWidth);
		},
	);

	// Make sure we clean up our timer
	foundation.destroy = _.wrap(foundation.destroy, (destroy) => {
		textfield.notchOutlinePatchTimeout &&
			clearTimeout(textfield.notchOutlinePatchTimeout);
		destroy.call(foundation);
	});

	// Fun hack for our inputs that have floating labels regardless of having a value or not
	const forceFloat =
		adapter.hasLabel() &&
		textfield.label_.root_.classList.contains(
			'mdc-floating-label--float-above',
		);

	// Since this patch is applied after init and init calls float label if there is a value, call it again
	// As seen in foundation.init:
	if (adapter.isFocused()) {
		foundation.inputFocusHandler_();
	} else if (forceFloat || (adapter.hasLabel() && foundation.shouldFloat)) {
		foundation.notchOutline(true);
		adapter.floatLabel(true);
	}
};
